<script>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from "swiper/vue";

export default {
    name: "FeedArticles",
    components:{
        Swiper,
        SwiperSlide
      },
    setup(){
      const testimonies = ref([])
      return { testimonies}
    }
}

</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import feed-articles
</style>
